// extracted by mini-css-extract-plugin
export default {"width":"VerificationQR_width__EwGqF","text":"VerificationQR_text__Euzml","error__qr":"VerificationQR_error__qr__Klcv5","refreshIcon":"VerificationQR_refreshIcon__Nb9Zj"};